module.exports = __webpack_public_path__ + "img/sun.387fd7d7.svg";